module.exports = __webpack_public_path__ + "static/media/1007102.6aba2b85.png";